import http, { cb } from "../http-common";
import axios from "axios";

const route = "documentos"

function http_doc() {
    const token = localStorage.getItem(process.env.REACT_APP_TOKEN_KEY);
    return axios.create({
        baseURL: process.env.REACT_APP_API_URL,
        headers: {
            "content-type": 'multipart/form-data;boundary=----WebKitFormBoundaryyrV7KO0BoCBuDbT',
            "Accept": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Authorization": token ? `Bearer ${token}` : null
        }
    })
}

function http_json() {
    const token = localStorage.getItem(process.env.REACT_APP_TOKEN_KEY);
    return axios.create({
        baseURL: process.env.REACT_APP_API_URL,
        headers: {
            "content-type": 'application/json',
            "Accept": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Authorization": token ? `Bearer ${token}` : null,
        },
        responseType: 'arraybuffer'
    })
}



class DocumentosService {


    update(data, id) {
        return http().put(`/${route}/${id}`, data).then(cb);
    }

    delete(id) {
        return http().delete(`/${route}/${id}`).then(cb);
    }

    upload(data) {
        return http_doc().post(`/${route}/file/upload`, data).then(cb);
    }

    load(file) {
        return http_json().get(`/${route}/file/load/${file}`).then(cb);
    }

    delete_file(file, id, name) {
        return http_json().delete(`/${route}/file/delete/${file}&${id}&${name}`).then(cb);
    }

}

export default new DocumentosService();